import React from "react";
import {PermissionGuard} from "../../components/PermissionGuard";
import {StandardLayout} from "../../components/StandardLayout";
import {DatabaseManagementFeature} from "../../features/databaseManagement";

const ALLOWED_PERMISSION = 'databaseManagement'

const DatabaseManagementPage = ({
  userToken,
  userPermissions,
}) => (
  <PermissionGuard
    userToken={userToken}
    userPermissions={userPermissions}
    permissionKey={ALLOWED_PERMISSION}
  >
    <StandardLayout
      headerTitle="資料庫備份管理"
      body={<DatabaseManagementFeature />}
    />
  </PermissionGuard>
)

export default DatabaseManagementPage
